// extracted by mini-css-extract-plugin
export var readonly = "_e8-1";
export var star = "_e8-0";